import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function AdminLoginPage() {
  const { login, admin, loading } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center font-serif text-2xl">Loading…</div>;
  if (admin) return <Navigate to="/admin/orders" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      toast.success("Welcome, admin.");
      nav("/admin/orders");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Sign in failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16 bg-[#FBF6F1]">
      <div className="w-full max-w-md bg-white border border-[#F0DFD0] rounded-lg p-10">
        <div className="eyebrow">Internal</div>
        <h1 className="font-serif text-3xl mt-3">Admin Sign In</h1>
        <p className="text-[#6B5757] mt-3 text-sm">
          Order status transitions require an admin session. Contact your ops lead if you need access.
        </p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-widest text-[#6B5757]">Email</span>
            <input
              data-testid="admin-auth-email"
              type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-4 py-3 text-sm bg-white border border-[#E5CDBB] rounded-md focus:outline-none focus:border-[#2A1F1F]"
            />
          </label>
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-widest text-[#6B5757]">Password</span>
            <input
              data-testid="admin-auth-password"
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-4 py-3 text-sm bg-white border border-[#E5CDBB] rounded-md focus:outline-none focus:border-[#2A1F1F]"
            />
          </label>
          {err && <div data-testid="admin-auth-error" className="text-sm text-[#B85C56]">{err}</div>}
          <button
            data-testid="admin-auth-submit"
            type="submit" disabled={busy}
            className="btn-primary w-full disabled:opacity-60"
          >
            {busy ? "Please wait…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
